import * as React  from 'react'
import { connect } from 'react-redux'

import createMuiTheme    from '@material-ui/core/styles/createMuiTheme'
import MuiThemeProvider  from '@material-ui/core/styles/MuiThemeProvider'
import { ThemeProvider } from 'styled-components'
import * as defaulTheme from '../../theme'

import { muiPaletteOverride, success, toolbarColor, buttonColor }                     from '../../theme'
import { ApplicationState, selectLocale, selectThemeType } from '../../redux'

const mstp = (state: ApplicationState) => ({
  isDark: selectThemeType(state),
  locale: selectLocale(state),
})

interface ThemeProps {
  children: React.ReactNode
}

type Props =
  ThemeProps
  & ReturnType<typeof mstp>

const Theme = ({ children, isDark }: Props) => {
  const theme = createMuiTheme({
    palette: {
      ...muiPaletteOverride,
      type: isDark ? 'dark' : 'light',
    },
    overrides: {
      MuiStepIcon: {
        completed: {
          color: success.main + ' !important',
        },
      },
      MuiToolbar: {
        root: {
          backgroundColor: toolbarColor
        }
      },
      MuiButton: {
        root:{
          backgroundColor: buttonColor
        }
      }
    },
  })

  return (
    <ThemeProvider theme={{...defaulTheme, ...theme}}>
      <MuiThemeProvider theme={theme}>
        {children}
      </MuiThemeProvider>
    </ThemeProvider>
  )
}

export default connect(mstp)(Theme)



// WEBPACK FOOTER //
// ./src/contexts/Theme/Theme.tsx